// extracted by mini-css-extract-plugin
export var readonly = "_dz-1";
export var star = "_dz-0";